import {AppConfigService} from '../config/app-config.service';


export function initializer(appConfig: AppConfigService): () => Promise<any> {
  return (): Promise<any> => {
    return appConfig.load();
  };
}
